import { registerComponent } from '../app'
import {
	OPEN_MENU,
	CLOSE_MENU,
	ENABLE_LIGHT_MODE,
	DISABLE_LIGHT_MODE,
	SHOPIFY_UPDATE_ELEMENT
} from '../events'

const Body = (scope, el) => {
	const props = {
		loadedClass: 'loaded',
		menuOpenClass: 'menu-open',
		lightModeClass: 'light-mode',
		editorClass: 'theme-editor'
	}

	scope.on(OPEN_MENU, () => {
		window.requestAnimationFrame(() => el.classList.add(props.menuOpenClass))
	})

	scope.on(CLOSE_MENU, () => {
		window.requestAnimationFrame(() => el.classList.remove(props.menuOpenClass))
	})

	scope.on(ENABLE_LIGHT_MODE, () => {
		window.requestAnimationFrame(() => el.classList.add(props.lightModeClass))
	})

	scope.on(DISABLE_LIGHT_MODE, () => {
		window.requestAnimationFrame(() => el.classList.remove(props.lightModeClass))
	})

	scope.on(SHOPIFY_UPDATE_ELEMENT, () => {
		el.classList.add(props.editorClass)
	})

	scope.start(() => el.classList.add(props.loadedClass))
}

registerComponent('body', Body)
